<template>
  <div class="editor">
    <quill-editor
      ref="editor"
      v-model="innerContent"
      :options="options"
      @ready="onReady"
    ></quill-editor>
    <el-upload action :before-upload="onBeforeUpload" style="display: none">
      <el-button ref="uploadBtn">点击上传</el-button>
    </el-upload>
  </div>
</template>

<script>
export default {
  name: "editor",
  components: {},
  props: {
    // .sync
    content: {
      type: String,
      default: "",
    },
    // 简易版本，没有超链接、图片上传、视频上传
    simple: {
      type: Boolean,
      default: false,
    },
    hasMathJax: {
      type: Boolean,
      default: false,
    },
    height: {
      type: Number,
    },
  },
  data() {
    return {
      quillEditor: null, // quill-editor 对象
      titleConfig: {
        "ql-bold": "加粗",
        "ql-color": "颜色",
        "ql-font": "字体",
        "ql-code": "插入代码",
        "ql-italic": "斜体",
        "ql-link": "添加链接",
        "ql-background": "背景颜色",
        "ql-size": "字体大小",
        "ql-strike": "删除线",
        "ql-script": "上标/下标",
        "ql-underline": "下划线",
        "ql-blockquote": "引用",
        "ql-header": "标题",
        "ql-indent": "缩进",
        "ql-list": "列表",
        "ql-align": "文本对齐",
        "ql-direction": "文本方向",
        "ql-code-block": "代码块",
        "ql-formula": "公式",
        "ql-image": "图片",
        "ql-video": "视频",
        "ql-clean": "清除字体样式",
      },
      options: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
            ["blockquote", "code-block"], // 引用  代码块
            [{ header: 1 }, { header: 2 }], // 1、2 级标题
            [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
            [{ script: "sub" }, { script: "super" }], // 上标/下标
            [{ indent: "-1" }, { indent: "+1" }], // 缩进
            // [{'direction': 'rtl'}],                         // 文本方向
            [{ size: ["small", false, "large", "huge"] }], // 字体大小
            [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
            [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
            [{ font: [] }], // 字体种类
            [{ align: [] }], // 对齐方式
            ["clean"], // 清除文本格式
          ],
        },
        placeholder: "请输入内容...",
      },
      innerContent: "",
      uploadType: "",
    };
  },
  created() {
    if (!this.simple) {
      const toolbars = ["link", "image", "video"]; // 链接、图片、视频
      if (this.hasMathJax) {
        toolbars.push("formula"); // 公式
      }
      this.options.modules.toolbar.push(toolbars);
    }
    this.$eventBus.$on("getFormulaImg", this.onGetFormulaImg);
  },
  destroyed() {
    this.$eventBus.$off("getFormulaImg", this.onGetFormulaImg);
  },
  mounted() {
    this.addQuillTitle();
    if (this.height) {
      const $ = window.$;
      const toolbarHeight = parseInt($(".ql-toolbar").css("height"));
      const bodyHeight = Math.max(100, this.height - toolbarHeight);
      $(".ql-editor").css({ height: bodyHeight + "px" });
    }
  },
  watch: {
    innerContent(val) {
      this.$emit("update:content", val);
    },
    content: {
      immediate: true,
      async handler(val) {
        // console.log("editor: " + val);
        if (val == this.innerContent) return;
        this.innerContent = await this.formatContent(val);
        // console.log(this.innerContent);
      },
    },
  },
  computed: {
    uploadUrl() {
      switch (this.$identity.name) {
        case "teacher":
          return "/api/lector/public/file";
        case "assist":
          return "/api/assistants/public/files";
        case "student":
          return "/api/app/public/file";
      }
      return "";
    },
  },
  methods: {
    // method
    getContentLen() {
      const str = this.quillEditor.container.innerText;
      const strLen = str.length;
      if (strLen == 1 && str.trim().length == 0) {
        return 0;
      }
      return strLen;
    },
    // on event
    onReady(quill) {
      this.quillEditor = quill;
      const toolbar = quill.getModule("toolbar");
      toolbar.addHandler("image", state => {
        if (!state) return;
        this.uploadType = "image";
        this.$refs.uploadBtn.$el.click();
      });
      toolbar.addHandler("video", state => {
        if (!state) return;
        this.uploadType = "video";
        this.$refs.uploadBtn.$el.click();
      });
      toolbar.addHandler("formula", state => {
        if (!state) return;
        const selection = this.quillEditor.getSelection();
        Object.assign(this.$store.state.formulaDlg, {
          show: true,
          uid: this.$refs.editor._uid,
          selectionIndex: selection ? selection.index : 0,
        });
      });
    },
    onBeforeUpload(file) {
      if (file.size > 5 * 1024 * 1024) {
        this.$info("不能大于5M");
        return;
      }
      const formData = new FormData();
      formData.append("file", file);
      this.$http.post(this.uploadUrl, formData).then(data => {
        const selection = this.quillEditor.getSelection();
        this.quillEditor.insertEmbed(
          selection ? selection.index : 0,
          this.uploadType,
          data.url,
        );
      });
      return;
    },
    onGetFormulaImg(uid, selectionIndex, base64) {
      if (uid != this.$refs.editor._uid) return;
      this.quillEditor.insertEmbed(selectionIndex, "image", base64);
    },
    // other
    addQuillTitle() {
      const oToolBar = document.querySelector(".ql-toolbar"),
        aButton = oToolBar.querySelectorAll("button"),
        aSelect = oToolBar.querySelectorAll("select");
      aButton.forEach(item => {
        if (item.className === "ql-script") {
          item.value === "sub" ? (item.title = "下标") : (item.title = "上标");
        } else if (item.className === "ql-indent") {
          item.value === "+1"
            ? (item.title = "向右缩进")
            : (item.title = "向左缩进");
        } else {
          item.title = this.titleConfig[item.classList[0]];
        }
      });
      aSelect.forEach(item => {
        item.parentNode.title = this.titleConfig[item.classList[0]];
      });
    },
    async formatContent(content) {
      if (!this.hasMathJax) return content;
      let oDiv = document.createElement("div");
      oDiv.innerHTML = content;
      await window.MathJax.typesetPromise([oDiv]);
      const mjxs = oDiv.querySelectorAll("mjx-container");
      for (const mjx of mjxs) {
        const svg = mjx.querySelector("svg");
        if (svg) {
          const img = await this.svgPng(svg);
          mjx.parentNode.replaceChild(img, mjx);
        }
      }
      return oDiv.innerHTML;
    },
    // #### Svg 转 png
    svgPng(svg) {
      return new Promise(resolve => {
        const s = new XMLSerializer().serializeToString(svg);
        const src = `data:image/svg+xml;base64,${btoa(
          unescape(encodeURIComponent(s)),
        )}`;
        const img = new Image(); // 创建图片容器承载过渡
        const ret = new Image();
        // ret.style["vertical-align"] = "middle";
        ret.className = "test";
        img.onload = () => {
          // 图片创建后再执行，转Base64过程
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const context = canvas.getContext("2d");
          context.drawImage(img, 0, 0);
          const imgBase64 = canvas.toDataURL("image/png");
          // console.log(imgBase64, "Svg 转 png");
          ret.src = imgBase64;
          resolve(ret);
        };
        img.src = src;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.editor {
  line-height: normal;
  background-color: #fff;
  /deep/ {
    .ql-container {
      border-radius: 0 0 4px 4px;
    }
    .ql-editor {
      min-height: 100px;
    }
    .ql-toolbar {
      border-radius: 4px 4px 0 0;
    }
    .ql-snow .ql-tooltip[data-mode="formula"]::before {
      content: "输入公式：";
    }
    .ql-snow .ql-tooltip.ql-editing a.ql-action::after {
      content: "保存";
    }
  }
}
</style>
